export { default } from "./TablePagination.js";
export { default as tablePaginationClasses } from "./tablePaginationClasses.js";
export * from "./tablePaginationClasses.js";